/**
 * created by hezq on 2019年03月28日
 *
 * description： ajax封装请求
 *
 */
import Qs from 'qs'
import Cookies from 'js-cookie'
import utils from 'libs/utils'
const Base64 = require('js-base64').Base64

const config = require('./config.js')

let http = {
	ajax (options, success, error) {
		// let user = tools.store.getLS('user', true) || null;
		// 处理同一个浏览器登录2个账号信息不同步的问题
		// if (user !== null && user.userid !== (Cookies.get(config.PLAT + config.DOMAIN + '.userid', {
		// 		domain: config.DOMAIN
		// 	}))) {
		// 	window.location.reload();
		// }

		// 可以只传字符串，默认作为url处理
		if (typeof options === 'string') {
			options = {
				url: options
			}
		}

		// 默认get请求
		options.type = options.type || 'GET'
		// 如果options里没传data，默认{}
		options.data = options.data || {}

		let defaultConfig = {
			dataType: options.dataType || 'json',
			type: options.type,
			url: options.url,
			cache: false,
			// dataFilter: function(data, type) {
			// 	// return JSON.stringify(utils.recursive(JSON.parse(data), function(obj) {
			// 	// 	if(/^[+-]?[1-9]?[0-9]*\.[0-9]*$/.test(obj)) {
			// 	// 		return Number(obj).toFixed(2);
			// 	// 	} else {
			// 	// 		return obj;
			// 	// 	}
			// 	// }));
			// 	return data.replace(/\:(\d+(\.\d+)?)\,/g,':"$1",');
			// },
			beforeSend (xhr) {
				// 设置跨域凭证
				xhr.withCredentials = true
				// 设置Authorization
				xhr.setRequestHeader('Authorization', Cookies.get(config.PLAT + config.DOMAIN + '.access_token', {
					domain: config.DOMAIN
				}) || '')
			},
			success (res) {
				// 根据code统一处理
				if (res.code === 400) {
					utils.alert({
						message: res.msg || config.MSG_SERVER_ERROR,
						type: 'error',
						duration: 3000
					})
					error && error()
				} else if (res.code === 401) {
					utils.alert({
						message: config.MSG_NO_LOGIN,
						type: 'error',
						duration: 3000
					})
					utils.loginOut()
				} else if (res.code === 403) {
					utils.alert({
						message: config.MSG_NO_AUTH,
						type: 'error',
						duration: 1000
					})
					setTimeout(() => {
						utils.herfNoAuth({
							url: Base64.encode(options.url)
						})
					}, 1000)
				} else {
					success && success(res.data || {})
				}
			},
			error (xhr, status, errorThrown) {
				utils.alert({
					message: '服务休息中，请稍后再试！',
					type: 'error',
					duration: 5000
				})

				error && error()
			}
		}

		if (options.type === 'GET' || options.type === 'DELETE') {
			defaultConfig.contentType = 'application/x-www-form-urlencoded;charset=utf-8;'
			options.data.sid = config.SSID
			options.data.ssid = config.SSID
			options.data.subsystem = config.SUB_SYSTEM
			options.data = {...options.data, ...options.params}
			defaultConfig.url += '?' + Qs.stringify(options.data)
		} else {
			defaultConfig.contentType = 'application/json;charset=utf-8;'
			options.params = options.params || {}
			options.params.ssid = config.SSID
			options.data.sid = config.SSID
			options.data.subsystem = config.SUB_SYSTEM
			if (options.params) {
				if (defaultConfig.url.indexOf('?') === -1) {
					defaultConfig.url += '?' + Qs.stringify(options.params)
				} else {
					defaultConfig.url += '&' + Qs.stringify(options.params)
				}
			}
			defaultConfig.data = JSON.stringify(options.data)
		}

		$.support.cors = true

		$.ajax(defaultConfig)
	},

	// jsonp请求
	jsonp (options, success, error) {
		// let user = tools.store.getLS('user', true) || null;
		// 处理同一个浏览器登录2个账号信息不同步的问题

		// if (user !== null && user.userid !== Cookies.get(config.PLAT + config.DOMAIN + '.userid', {
		// 		domain: config.DOMAIN
		// 	})) {
		// 	window.location.reload();
		// }

		// 可以只传字符串，默认作为url处理
		if (typeof options === 'string') {
			options = {
				url: options
			}
		}
		// 如果options里没传data，默认{}
		options.data = options.data || {}
		// 默认带上参数ssid，接口需要
		options.data.sid = config.SSID
		options.data.ssid = config.SSID
		options.data.subsystem = config.SUB_SYSTEM
		// 解决在ie下请求缓存的问题 FIXME:cache设置为false默认带时间戳
		// options.data._ = new Date().getTime();

		// ajax配置项，详细参考：http://www.w3school.com.cn/jquery/ajax_ajax.asp
		let defaultConfig = {
			dataType: 'jsonp',
			jsonp: 'jsoncallback',
			type: 'GET',
			url: options.url,
			cache: false,
			data: options.data,
			beforeSend (xhr) {
				// 设置跨域凭证
				xhr.withCredentials = true
				// 设置Authorization
				xhr.setRequestHeader('Authorization', Cookies.get(config.PLAT + config.DOMAIN + '.access_token', {
					domain: config.DOMAIN
				}) || '')
			},
			success (res) {
				if (window.location.href.indexOf('/pages/login/index.html') > 0) {
					if (res.code === 0) {
						success && success(res.data || {})
					} else {
						error && error(res.message)
					}
				} else {
					// 根据code统一处理
					if (res.code === 1) {
						utils.alert({
							message: res.message || config.MSG_SERVER_ERROR,
							type: 'error',
							duration: 3000
						})
						error && error()
					} else {
						success && success(res.data || {})
					}
				}
			},
			error (xhr, status, errorThrown) {
				utils.alert({
					message: '服务休息ing，请稍后再试！',
					type: 'error',
					duration: 5000
				})
				error && error()
			}
		}

		$.ajax(defaultConfig)
	},

	ajaxGetFile (options, filename, success, error) {
		options.data.sid = config.SSID
		options.data.ssid = config.SSID
		options.data.subsystem = config.SUB_SYSTEM
		options.data = {...options.data, ...options.params}
		let url = options.url + '?' + Qs.stringify(options.data)

		let xhr = new XMLHttpRequest()

		xhr.open('GET', url, true)
		xhr.responseType = 'blob'
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
		// 设置跨域凭证
		xhr.withCredentials = false
		// 设置Authorization
		xhr.setRequestHeader('Authorization', Cookies.get(config.PLAT + config.DOMAIN + '.access_token', {
			domain: config.DOMAIN
		}) || '')
		xhr.onload = function () {
			if (this.status === 200) {
				let blob = new Blob([xhr.response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})

				let reader = new FileReader()
				let fileReader = new FileReader()

				fileReader.readAsText(blob)
				fileReader.onload = function () {
					try {
						const res = JSON.parse(this.result)

						// 根据code统一处理
						if (res.code === 400) {
							utils.alert({
								message: res.msg || config.MSG_SERVER_ERROR,
								type: 'error',
								duration: 3000
							})
							error && error()
						} else if (res.code === 401) {
							utils.alert({
								message: config.MSG_NO_LOGIN,
								type: 'error',
								duration: 3000
							})
							utils.loginOut()
						} else if (res.code === 403) {
							utils.alert({
								message: config.MSG_NO_AUTH,
								type: 'error',
								duration: 1000
							})
							setTimeout(() => {
								utils.herfNoAuth({
									url: Base64.encode(options.url)
								})
							}, 1000)
						}
					} catch (err) {
						success && success()

						reader.readAsDataURL(blob)

						if (Boolean(window.ActiveXObject) || 'ActiveXObject' in window || navigator.userAgent.indexOf('Edge') > -1) {
							window.navigator.msSaveOrOpenBlob(blob, filename + '.xlsx')
							return
						}
						reader.onload = function (e) {
							let a = document.createElement('a')

							a.download = `${filename}.xlsx`
							a.href = e.target.result
							a.click()
						}
					}
				}
			} else {
				utils.alert({
					message: '服务休息中，请稍后再试！',
					type: 'error',
					duration: 5000
				})

				error && error()
			}
		}
		xhr.send()
	}

}

export default http



// WEBPACK FOOTER //
// ./src/libs/http.js